import {
  POST_COMMS_REQUEST,
  POST_COMMS_FAILURE,
  POST_COMMS_SUCCESS,
  FETCH_ELIGILITY_REQUEST,
  FETCH_ELIGILITY_FAILURE,
  FETCH_ELIGILITY_SUCCESS,
  FETCH_SYSTEM_MESSAGE_GROUPS_REQUEST,
  FETCH_SYSTEM_MESSAGE_GROUPS_FAILURE,
  FETCH_SYSTEM_MESSAGE_GROUPS_SUCCESS,
  FETCH_COMMS_LIST_REQUEST,
  FETCH_COMMS_LIST_FAILURE,
  FETCH_COMMS_LIST_SUCCESS,
  UPDATE_COMMS_REQUEST,
  UPDATE_COMMS_FAILURE,
  UPDATE_COMMS_SUCCESS,
  REMOVE_COMMS_REQUEST,
  REMOVE_COMMS_FAILURE,
  REMOVE_COMMS_SUCCESS,
  POST_REPAIR_TEMPLATE_REQUEST,
  POST_REPAIR_TEMPLATE_FAILURE,
  POST_REPAIR_TEMPLATE_SUCCESS,
  POST_TEST_COMMS_REQUEST,
  POST_TEST_COMMS_FAILURE,
  POST_TEST_COMMS_SUCCESS,
} from './action-types';

import {
  PostTestCommsRequest,
  PostTestCommsSuccess,
  PostTestCommsSuccessPayload,
  PostTestCommsFailure,
  PostTestCommsFailurePayload,
  PostRepairTemplateRequest,
  PostRepairTemplateSuccess,
  PostRepairTemplateSuccessPayload,
  PostRepairTemplateFailure,
  PostRepairTemplateFailurePayload,
  PostCommsRequest,
  PostCommsSuccess,
  PostCommsSuccessPayload,
  PostCommsFailure,
  PostCommsFailurePayload,
  FetchCommsRequest,
  FetchCommsSuccess,
  FetchCommsSuccessPayload,
  FetchCommsFailure,
  FetchCommsFailurePayload,
  FetchSystemMessageGroupsRequest,
  FetchSystemMessageGroupsSuccess,
  FetchSystemMessageGroupsFailure,
  FetchSystemMessageGroupsFailurePayload,
  FetchCommsListRequest,
  FetchCommsListSuccess,
  FetchCommsListSuccessPayload,
  FetchCommsListFailure,
  FetchCommsListFailurePayload,
  UpdateCommsRequest,
  UpdateCommsSuccess,
  UpdateCommsSuccessPayload,
  UpdateCommsFailure,
  UpdateCommsFailurePayload,
  RemoveCommsRequest,
  RemoveCommsSuccess,
  RemoveCommsSuccessPayload,
  RemoveCommsFailure,
  RemoveCommsFailurePayload,
} from './types';

export const postCommsRequest = (payload: any): PostCommsRequest => ({
  type: POST_COMMS_REQUEST,
  payload,
});

export const postCommsSuccess = (payload: PostCommsSuccessPayload): PostCommsSuccess => ({
  type: POST_COMMS_SUCCESS,
  payload,
});

export const postCommsFailure = (payload: PostCommsFailurePayload): PostCommsFailure => ({
  type: POST_COMMS_FAILURE,
  payload,
});

export const fetchCommsRequest = (payload: any): FetchCommsRequest => ({
  type: FETCH_ELIGILITY_REQUEST,
  payload,
});

export const fetchCommsSuccess = (payload: FetchCommsSuccessPayload): FetchCommsSuccess => ({
  type: FETCH_ELIGILITY_SUCCESS,
  payload,
});

export const fetchCommsFailure = (payload: FetchCommsFailurePayload): FetchCommsFailure => ({
  type: FETCH_ELIGILITY_FAILURE,
  payload,
});

export const fetchSystemMessageGroupsRequest = (payload: any): FetchSystemMessageGroupsRequest => ({
  type: FETCH_SYSTEM_MESSAGE_GROUPS_REQUEST,
  payload,
});

export const fetchSystemMessageGroupsSuccess = (payload: any): FetchSystemMessageGroupsSuccess => ({
  type: FETCH_SYSTEM_MESSAGE_GROUPS_SUCCESS,
  payload,
});

export const fetchSystemMessageGroupsFailure = (
  payload: FetchSystemMessageGroupsFailurePayload,
): FetchSystemMessageGroupsFailure => ({
  type: FETCH_SYSTEM_MESSAGE_GROUPS_FAILURE,
  payload,
});

export const fetchCommsListRequest = (payload: any): FetchCommsListRequest => ({
  type: FETCH_COMMS_LIST_REQUEST,
  payload,
});

export const fetchCommsListSuccess = (payload: FetchCommsListSuccessPayload): FetchCommsListSuccess => ({
  type: FETCH_COMMS_LIST_SUCCESS,
  payload,
});

export const fetchCommsListFailure = (payload: FetchCommsListFailurePayload): FetchCommsListFailure => ({
  type: FETCH_COMMS_LIST_FAILURE,
  payload,
});

export const updateCommsRequest = (payload: any): UpdateCommsRequest => ({
  type: UPDATE_COMMS_REQUEST,
  payload,
});

export const updateCommsSuccess = (payload: UpdateCommsSuccessPayload): UpdateCommsSuccess => ({
  type: UPDATE_COMMS_SUCCESS,
  payload,
});

export const updateCommsFailure = (payload: UpdateCommsFailurePayload): UpdateCommsFailure => ({
  type: UPDATE_COMMS_FAILURE,
  payload,
});

export const removeCommsRequest = (payload: any): RemoveCommsRequest => ({
  type: REMOVE_COMMS_REQUEST,
  payload,
});

export const removeCommsSuccess = (payload: RemoveCommsSuccessPayload): RemoveCommsSuccess => ({
  type: REMOVE_COMMS_SUCCESS,
  payload,
});

export const removeCommsFailure = (payload: RemoveCommsFailurePayload): RemoveCommsFailure => ({
  type: REMOVE_COMMS_FAILURE,
  payload,
});

export const postRepairTemplateRequest = (payload: any): PostRepairTemplateRequest => ({
  type: POST_REPAIR_TEMPLATE_REQUEST,
  payload,
});

export const postRepairTemplateSuccess = (payload: PostRepairTemplateSuccessPayload): PostRepairTemplateSuccess => ({
  type: POST_REPAIR_TEMPLATE_SUCCESS,
  payload,
});

export const postRepairTemplateFailure = (payload: PostRepairTemplateFailurePayload): PostRepairTemplateFailure => ({
  type: POST_REPAIR_TEMPLATE_FAILURE,
  payload,
});

export const postTestCommsRequest = (payload: any): PostTestCommsRequest => ({
  type: POST_TEST_COMMS_REQUEST,
  payload,
});

export const postTestCommsSuccess = (payload: PostTestCommsSuccessPayload): PostTestCommsSuccess => ({
  type: POST_TEST_COMMS_SUCCESS,
  payload,
});

export const postTestCommsFailure = (payload: PostTestCommsFailurePayload): PostTestCommsFailure => ({
  type: POST_TEST_COMMS_FAILURE,
  payload,
});
